/* (c) 2020-2023, Nextwave Logic, Inc. All Rights Reserved */
// baki

import React, { useState, useEffect, useContext, useRef } from 'react';
import moment from 'moment';
import { Button, Collapse, Label, Input, Modal, ModalHeader, ModalBody, ModalFooter, InputGroup } from 'reactstrap';
import { Link } from 'react-router-dom';
import { EmojiButton } from '@joeattardi/emoji-button';
import { Client as ConversationsClient } from '@twilio/conversations';
import Joyride, { STATUS } from 'react-joyride';

// import contexts
import { ThemeContext } from '../../../contexts/ThemeContext';
import { AuthContext } from '../../../contexts/AuthContext';

// import services
import DemoService from '../../../services/DemoService';

// local imports`
import ErrorBoundary from '../../general/ErrorBoundary';
import notificationSound from '../../../assets/notification.mp3';
import './ClientChat.css';
import { counsellors, sessions, messages as dbMessages } from '../demoData';

import sendIcon from '../../../assets/send.png';
import searchIcon from '../../../assets/search.png';

let copyMessages = [];
let currentSearchResult = null;
let currentSearchPage = 0;
let searchResult = [];
let pageSize = 30;

// tutorial pending

const ClientChat = props => {

    let timeout = 0;
    let audio = new Audio(notificationSound);
    let counter = 0;

    // contexts
    const { theme, colors, fontFamily, fontSize, fontWeight } = useContext(ThemeContext);

    // states
    const [user, setUser] = useState({ firstName: "", lastName: "", email: "", selectedRole: '', roles: [], profileImage: "", demoTakenFor: [] });
    const [connectionLoading, setConnectionLoading] = useState(true);
    const [statusString, setStatusString] = useState("");
    const [selectedProvider, setSelectedProvider] = useState({ isTrue: false });
    const [showChatScrollDown, setShowChatScrollDown] = useState(false);
    const [messages, setMessages] = useState([]);
    const [isTyping, setIsTyping] = useState({ status: false, identity: "" });
    const [message, setMessage] = useState("");
    const [search, setSearch] = useState({ visible: false, value: "" });
    const [showNewMessageLine, setShowNewMessageLine] = useState(false);
    const [listOfSessions, setListOfSessions] = useState({
        completedSessions: [],
        upcomingSessions: [],
        cancelledSessions: [],
        rescheduleRequestedSession: []
    });
    const [tutorial, setTutorial] = useState({
        status: false,
        steps: [
            {
                content: <h2>Chat with your selected counsellor from here!</h2>,
                placement: 'center',
                target: '#clientChatDiv',
            }
        ]
    });
    let helpers = null;

    const [isOpenDetails, setIsOpenDetails] = useState(false);
    const [isOpenUpcoming, setIsOpenUpcoming] = useState(false);
    const [isOpenPrevious, setIsOpenPrevious] = useState(false);
    const [toggleTopMenu, setToggleTopMenu] = useState(false);
    const [toggleLeftMenu, setToggleLeftMenu] = useState(false);

    useEffect(() => {
        document.getElementById("root").classList.value = "";
        document.getElementById("root").firstElementChild.firstElementChild.classList.value = "firstChildDiv";
        document.getElementById("root").firstElementChild.classList.value = "firstChildDiv";
        window.addEventListener('resize', getHeights);

        // getChatToken("QuietKendraUtica");
        // getUser();

        DemoService.getUserData().then(data => {
            if (data.isAuthenticated) {
                if (data.user.roles[0] === "DemoClient") {
                    setUser(data.user);
                    setSelectedProvider({ ...counsellors[0], isTrue: true, name: `${counsellors[0].title ? counsellors[0].title : ''} ${counsellors[0].firstName} ${counsellors[0].lastName}` });
                    setListOfSessions({
                        upcomingSessions: sessions,
                        completedSessions: [],//sessions,
                    });
                    setMessages(dbMessages);
                    copyMessages = dbMessages;
                    if (!data.user.demoTakenFor.includes("ClientChat")) {
                        setTutorial({ ...tutorial, status: true });
                    }
                    setConnectionLoading(false);
                    getHeights();
                } else {
                    // props.history.replace('PagePath');
                }
            } else {
                props.history.replace('/demo/signin');
            }
        })
        // getSubscriptionDetails();
        // getNotifications();

        return () => {
            leaveConversation();
            window.removeEventListener('resize', getHeights);
            document.getElementById("root").classList.value = "container container-fluid";
            document.getElementById("root").firstElementChild.firstElementChild.classList.value = "";
            document.getElementById("root").firstElementChild.classList.value = "";
        };
    }, [])

    useEffect(() => {
        if (toggleLeftMenu) {
            document.getElementById("asideContainer").classList = "col-md-3 col-12 d-flex flex-column";
            if (!document.getElementById("mainContainer").classList.contains("d-none")) {
                document.getElementById("mainContainer").classList.add("d-none");
            }
        } else {
            document.getElementById("asideContainer").classList = "col-md-3 d-md-block col-12 d-none";
            if (document.getElementById("mainContainer").classList.contains("d-none")) {
                document.getElementById("mainContainer").classList.remove("d-none");
                getHeights();
            }
        }
    }, [toggleLeftMenu]);

    useEffect(() => {
        if (search.status) {
            document.getElementById("searchInput").focus();
        }
    }, [search.status]);

    useEffect(() => {
        removeMark();
        if (search.value) {
            currentSearchPage = 0;
            searchResult = [];
            performSearch();
        }
    }, [search.value]);

    useEffect(() => {
        if (!showNewMessageLine)
            scrollToBottom();
        if (currentSearchResult) {
            // console.log("addMessage");
            // setTimeout(() => {
            let element = document.getElementById(`msg${currentSearchResult.index}`);
            for (let i = 0; i < 10; i++) {
                element.parentElement.scrollIntoView();
            }
            // }, 50);
        }
    }, [messages.length])

    useEffect(() => {
        if (isTyping.identity === "provider")
            getHeights();
    }, [isTyping.status])

    const loadEmojiKeyborad = () => {
        const picker = new EmojiButton();
        const trigger = document.querySelector('.trigger');
        picker.on('emoji', selection => {
            // `selection` object has an `emoji` property
            // containing the selected emoji
            onEmojiClick(null, selection);
        });
        trigger.addEventListener('click', () => picker.togglePicker(trigger));
    }

    const getHeights = () => {
        try {
            const mainHeight = document.getElementById("mainContainer").offsetHeight;
            const headerHeight = document.getElementById("header").offsetHeight;
            const typingDivHeight = document.getElementById("typingDiv") ? document.getElementById("typingDiv").offsetHeight : 0;
            const footerHeight = document.getElementById("footer").offsetHeight;
            const chatDivHeight = mainHeight - headerHeight - typingDivHeight - footerHeight;
            document.getElementById('chatDiv').setAttribute("style", `height: ${chatDivHeight}px`);
            document.getElementById('chatDiv').style.height = `${chatDivHeight}px`;
            scrollToBottom();
        } catch (err) { }
    }

    const handleChatScroll = (e) => {
        let chatList = e.target;
        const value = chatList.scrollHeight - chatList.scrollTop - chatList.clientHeight;
        if (!showNewMessageLine && value > 200) {
            setShowNewMessageLine(true)
        } else if (showNewMessageLine && value < 200) {
            setShowNewMessageLine(false)
        }
        if (!showChatScrollDown && value > 500) {
            setShowChatScrollDown(true)
        } else if (showChatScrollDown && value < 500) {
            setShowChatScrollDown(false)
        }
    }

    function scrollToBottom() {
        try {
            let someElement = document.getElementById('chat');
            someElement.scrollTop = someElement.scrollHeight + document.getElementById('chat').lastChild.offsetHeight;
        } catch (err) { }
    }

    const onEmojiClick = (emojiObject) => {
        setMessage(message => message + emojiObject.emoji);
    }

    const leaveConversation = () => {
        // console.log("leaveConversation");
        setStatusString("");
        searchResult = [];
        setIsTyping({ status: false, identity: "" });
        setMessage("");
        setMessages([]);
        copyMessages = [];
    }

    const addMessage = (item) => {
        if (item.author !== "client") {
            audio.play();
        }
        setMessages(messages => [...messages, item]);
        copyMessages.push(item);
    }

    const handleTyping = (e) => {
        if (e.keyCode === 13) {
            document.getElementById('sendButton').click();
        }
    }

    const sendMessage = () => {
        if (message !== '') {
            // selectedConversation.sendMessage(message);
            setIsTyping({ status: true, identity: 'provider' });
            addMessage({ author: 'client', body: message });
            setMessage('');
            setTimeout(() => {
                addMessage({ author: 'provider', body: "Hello, This is a demo message" });
                setIsTyping({ status: false, identity: 'provider' });
            }, [1000]);
        }
    }

    // search functions
    const handleSearch = (value) => {
        if (timeout) clearTimeout(timeout);
        timeout = setTimeout(() => {
            setSearch({ ...search, value: value });
        }, 500);
    }

    const performSearch = async () => {
        let tempArray = [];
        let start = copyMessages.length - 1 - (pageSize * currentSearchPage);
        let end = 0;
        for (let i = start; i >= end; i--) {
            let position = copyMessages[i].body.toLowerCase().search(search.value.toLowerCase());
            if (position > -1)
                tempArray.push({ start: position, index: i });
        }
        searchResult.push(tempArray);
        if (searchResult.length !== 0) {
            currentSearchPage = searchResult.length - 1;
        }
        currentSearchResult = searchResult[currentSearchPage][0];
        await addMark();
    }

    const searchUpDown = async (direction) => {
        if (searchResult.length > 0) {
            let arrayIndex = await searchResult[currentSearchPage].findIndex(item => item.index === currentSearchResult.index);
            if (arrayIndex > -1) {
                if (direction === "up") {
                    if (searchResult[currentSearchPage].length > 0 && searchResult[currentSearchPage][(searchResult[currentSearchPage].length - 1)].index < currentSearchResult.index) {
                        await removeMark();
                        currentSearchResult = searchResult[currentSearchPage][arrayIndex + 1];
                        // console.log('1', currentSearchResult);
                        await addMark();
                    } else {
                        if (searchResult.length > (currentSearchPage + 1)) {
                            currentSearchPage = currentSearchPage + 1;
                            while (searchResult[currentSearchPage].length === 0) {
                                currentSearchPage = currentSearchPage + 1;
                            }
                            await removeMark();
                            currentSearchResult = searchResult[currentSearchPage][0];
                            // console.log('2', currentSearchResult);
                            await addMark();
                        } else {
                            // console.log("The end up");
                        }
                    }
                } else if (direction === "down") {
                    if (searchResult[currentSearchPage][0].index > currentSearchResult.index) {
                        // console.log("currentSearchPage", currentSearchPage, "searchResult", searchResult, "current", currentSearchResult);
                        await removeMark();
                        currentSearchResult = searchResult[currentSearchPage][arrayIndex - 1];
                        await addMark();
                    } else if (currentSearchPage > 0) {
                        // console.log("currentSearchPage", currentSearchPage, "searchResult", searchResult, "current", currentSearchResult);
                        currentSearchPage = currentSearchPage - 1;
                        while (searchResult[currentSearchPage].length === 0) {
                            currentSearchPage = currentSearchPage - 1;
                        }
                        await removeMark();
                        currentSearchResult = searchResult[currentSearchPage][(searchResult[currentSearchPage].length - 1)];
                        await addMark();
                    } else {
                        // console.log("The end down");
                    }
                }
            }
        }
    }

    const addMark = async () => {
        if (currentSearchResult) {
            let element = document.getElementById(`msg${currentSearchResult.index}`);
            let text = element.innerText;
            let re = new RegExp(search.value, "gi"); // search for all instances
            let newText = text.replace(re, `<mark>${text.substr(currentSearchResult.start, search.value.length)}</mark>`);
            element.innerHTML = newText;
            element.parentElement.scrollIntoView();
        }
    }

    const removeMark = async () => {
        if (currentSearchResult) {
            let element = document.getElementById(`msg${currentSearchResult.index}`);
            let text = element.innerText;
            let newText = text.replace("<mark>", "");
            newText = newText.replace("</mark>", "");
            element.innerHTML = newText;
        }
    }

    const clearSearch = async () => {
        searchResult = [];
        setSearch({ ...search, value: "" });
        document.getElementById("searchInput").value = "";
    }

    const toggleDetails = () => setIsOpenDetails(!isOpenDetails);
    const toggleUpcoming = () => setIsOpenUpcoming(!isOpenUpcoming);
    const togglePrevious = () => setIsOpenPrevious(!isOpenPrevious);

    const handleJoyrideCallback = (data) => {
        const { status, type } = data;
        const finishedStatuses = [STATUS.FINISHED, STATUS.SKIPPED];

        if (finishedStatuses.includes(status)) {
            if (!user.demoTakenFor.includes("ClientChat")) {
                DemoService.markVisited("ClientChat");
                setUser({ ...user, demoTakenFor: [...user.demoTakenFor, "ClientChat"] });
            }
            setTutorial({ ...tutorial, status: false });
        }
    };

    const getHelpers = (paramHelpers) => {
        helpers = paramHelpers;
    };

    // function's return
    return (
        <div id="clientChatDiv" className="clientChatWindow row m-0">
            <ErrorBoundary errorAt="At Client ClientChat Joyride">
                <Joyride
                    callback={handleJoyrideCallback}
                    continuous={true}
                    getHelpers={getHelpers}
                    run={tutorial.status}
                    scrollToFirstStep={true}
                    showProgress={false}
                    showSkipButton={false}
                    steps={tutorial.steps}
                    locale={{ last: 'Finish' }}
                    styles={{
                        options: {
                            primaryColor: "rgb(56, 78, 115)",
                            zIndex: 10000,
                        },
                    }}
                />
            </ErrorBoundary>
            {connectionLoading ? <div id="overlay"><div className="h-100 d-flex"><h3 className="m-auto text-center">{statusString}</h3></div></div> : null}
            <div id="asideContainer" className="col-md-3 col-12 d-flex flex-column">
                <div className="d-flex align-items-center">
                    {toggleLeftMenu ? (
                        <h4 className="backBtn" onClick={() => setToggleLeftMenu(false)}>
                            <i className="fas fa-chevron-left" style={{ color: "white" }}></i>
                        </h4>
                    ) : null}

                    <h5 className="mt-1 ml-2">
                        Your Counsellor
                    </h5>
                </div>
                <div className="d-flex flex-column align-items-center">
                    <i style={{ fontSize: "2rem", margin: "1rem", color: "white" }} className="fas fa-user"></i>
                    <h5>
                        {selectedProvider.name}
                    </h5>
                </div>

                {/* Other details */}
                <div className="otherDetails mt-2">
                    <button
                        type="button"
                        onClick={toggleDetails}
                        className="pb-2 d-flex align-items-center justify-content-between px-0 mx-2 mb-2"
                    >
                        Other Details
                        {isOpenDetails ? (
                            <i className="fas fa-angle-up icon" style={{ fontSize: "1.4rem", color: "white" }}></i>
                        ) : (
                            <i className="fas fa-angle-right icon" style={{ fontSize: "1.4rem", color: "white" }}></i>
                        )}
                    </button>
                    <Collapse isOpen={isOpenDetails}>
                        <ul className="ml-3">
                            <div className="d-flex align-items-center">
                                <i className="fas fa-map-marker-alt mr-2"></i>
                                <li className="ml-2">{`${selectedProvider.city}, ${selectedProvider.state}, ${selectedProvider.country}`}</li>
                            </div>

                            <div className="d-flex align-items-center my-1">
                                <i className="fas fa-envelope mr-2"></i>
                                <li className="ml-2">{selectedProvider.email}</li>
                            </div>

                            <div className="d-flex align-items-center my-1">
                                <i className="fas fa-phone-alt mr-2"></i>
                                <li className="ml-2">{selectedProvider.phone}</li>
                            </div>
                        </ul>
                    </Collapse>
                </div>

                {/* Upcoming Sessions */}
                <div className="upcomingSessions">
                    <button
                        type="button"
                        onClick={toggleUpcoming}
                        className="pb-2 px-0 mb-2 mx-2 d-flex align-items-center justify-content-between"
                    >
                        Upcoming Sessions:
                        {isOpenUpcoming ? (
                            <i className="fas fa-angle-up icon" style={{ fontSize: "1.4rem", color: "white" }}></i>
                        ) : (
                            <i className="fas fa-angle-right icon" style={{ fontSize: "1.4rem", color: "white" }}></i>
                        )}
                    </button>
                    <Collapse isOpen={isOpenUpcoming}>
                        <ul>
                            {
                                listOfSessions.upcomingSessions.map((item, index) => (
                                    <div key={index} className="d-flex flex-row justify-content-between align-items-center mx-2">
                                        {
                                            // change needed
                                            item.modeOfServiceSelected === "call" ?
                                                <i className="fas fa-phone-alt mx-2"></i> :
                                                <i className="fas fa-video mx-2"></i>
                                        }
                                        <li className="mr-5">{moment(item.date).format('DD/MM/YYYY')}</li>
                                        <li className="ml-4 mr-2">{moment(item.date).format('hh:mm A')}</li>
                                    </div>
                                ))
                            }
                        </ul>
                    </Collapse>
                </div>

                {/* Previous Sessions */}
                <div className="previousSessions">
                    <button
                        type="button"
                        onClick={togglePrevious}
                        className="pb-2 px-0 mb-2 mx-2 d-flex align-items-center justify-content-between"
                    >
                        Previous Sessions:
                        {isOpenPrevious ? (
                            <i className="fas fa-angle-up icon" style={{ fontSize: "1.4rem", color: "white" }}></i>
                        ) : (
                            <i className="fas fa-angle-right icon" style={{ fontSize: "1.4rem", color: "white" }}></i>
                        )}
                    </button>
                    <Collapse isOpen={isOpenPrevious}>
                        <ul>
                            {
                                listOfSessions.completedSessions.map((item, index) => (
                                    <div key={index} className="d-flex flex-row justify-content-between align-items-center mx-2">
                                        {
                                            item.modeOfServiceSelected === "call" ?
                                                <i className="fas fa-phone-alt mx-2"></i> :
                                                <i className="fas fa-video mx-2"></i>
                                        }
                                        <li className="mr-5">{moment(item.date).format('DD/MM/YYYY')}</li>
                                        <li className="ml-4 mr-2">{moment(item.date).format('hh:mm A')}</li>
                                    </div>
                                ))
                            }
                        </ul>
                    </Collapse>
                </div>
            </div>

            <div id="mainContainer" className="col-md-9 col-12 d-md-block openMainContainer">
                <div id="header" className="d-flex align-items-center">

                    {
                        search.status ? [
                            <Button key="1" className="iconButton my-auto" style={{ color: colors.primary }} onClick={() => { setSearch({ status: false, value: "" }); removeMark() }}><i className="fas fa-arrow-left"></i></Button>,
                            <InputGroup key="2" className="d-flex my-auto" style={{ width: "100%", marginRight: '15px', border: "1px solid #ced4da", borderRadius: "0.25rem" }}>
                                <Input id="searchInput" type="text" style={{ border: "none" }} placeholder="Search..." onChange={(e) => handleSearch(e.target.value)} />
                                <button className="btn bg-transparent" style={{ color: colors.primary }} onClick={() => clearSearch()}><i className="fa fa-times"></i></button>
                            </InputGroup>,
                            <Button key="3" className="iconButton my-auto" style={{ marginRight: '15px', color: colors.primary }} onClick={() => searchUpDown("up")} ><i className="fas fa-chevron-up"></i></Button>,
                            <Button key="4" className="iconButton my-auto" style={{ color: colors.primary }} onClick={() => searchUpDown("down")}><i className="fas fa-chevron-down"></i></Button>
                        ] : [
                            <i
                                key="1"
                                style={{ fontSize: "2rem", color: colors.primary }}
                                className="fas fa-user mr-2"
                                onClick={() => setToggleLeftMenu(true)}
                            ></i>,
                            <div key="2" className="display" onClick={() => setToggleLeftMenu(true)}>
                                <h2>{selectedProvider.name}</h2>
                                <h3>{true ? "online" : "offline"}</h3>
                            </div>,
                            <Button key="3" className="iconButton my-auto ml-auto" style={{ color: colors.primary }} onClick={() => setSearch({ status: true, value: "" })}><i className="fas fa-search"></i></Button>,
                            <Link key="4" to='/demo/client/booksession'>
                                <div className="actionBtnContainer">
                                    <div className="actionBtn d-icon">
                                        <i className="fas fa-phone-alt d-icon"></i>
                                    </div>
                                </div>
                            </Link>,
                            <Link key="5" to='/demo/client/booksession'>
                                <div className="actionBtnContainer">
                                    <div className="actionBtn d-icon">
                                        <i className="fas fa-video d-icon"></i>
                                    </div>
                                </div>
                            </Link>
                        ]
                    }

                    {/* Mobile Menu */}
                    <input
                        type="checkbox"
                        id="nav-toggle"
                        className="nav-toggle"
                        onChange={() => setToggleTopMenu(!toggleTopMenu)}
                    ></input>

                    <nav className={toggleTopMenu ? "" : "d-none"}>
                        <ul className="topMenuMobile">
                            <div className="d-flex flex-row justify-content-between align-items-center menu">
                                <h5>Menu</h5>
                            </div>

                            {/* <div className="d-flex flex-row align-items-center disp">
                                    <div className="actionBtn">
                                        <img height="20px" width="auto" src={searchIcon} alt="search" />
                                    </div>
                                    <li>Search</li>
                                </div> */}
                            <Link to='/demo/client/booksession'>
                                <div className="d-flex flex-row align-items-center disp">
                                    <div className="actionBtn">
                                        <i className="fas fa-phone-alt my-auto"></i>
                                    </div>
                                    <li>Request a voice call</li>
                                </div>
                            </Link>
                            <Link to='/demo/client/booksession'>
                                <div className="d-flex flex-row align-items-center disp">
                                    <div className="actionBtn">
                                        <i className="fas fa-video"></i>
                                    </div>
                                    <li>Request a video call</li>
                                </div>
                            </Link>
                        </ul>
                    </nav>

                    <label htmlFor="nav-toggle" className="navbar">
                        {toggleTopMenu ? (
                            <i
                                className="fas fa-times navCls mt-3"
                                style={{ color: "white", zIndex: "300", fontSize: "24px" }}
                            ></i>
                        ) : (
                            <i className="fas fa-bars icon" style={{ fontSize: "24px" }}></i>
                        )}
                    </label>
                </div>

                <div id="chatDiv" style={{ height: "400px" }}>
                    <ul id="chat" onScroll={(e) => handleChatScroll(e)}>
                        {
                            messages.length === 0 ?
                                <div className="d-flex h-100"><h5 className="m-auto">Seems like the conversation is empty. Send your first message by typing below.</h5></div>
                                :
                                messages.map((item, index) => ([
                                    item.isCustomMessage ?
                                        <li key={`message${index}`} data-index={index} style={{ textAlign: 'center' }}>
                                            <h2 style={{ fontWeight: '600', fontSize: '1rem' }}>{item.body}</h2>
                                        </li>
                                        :
                                        item.author === "client" ?
                                            <li key={`message${index}`} data-index={index} className="me">
                                                <div className="entete">
                                                    <h3>{moment(item.dateCreated).format('DD-MM-YYYY hh:mm A')}</h3>
                                                </div>
                                                <div id={`msg${index}`} className="message">
                                                    {item.body}
                                                </div>
                                            </li>
                                            :
                                            <li key={`message${index}`} data-index={index} className="you">
                                                <div className="entete">
                                                    <h3>{moment(item.dateCreated).format('DD-MM-YYYY hh:mm A')}</h3>
                                                </div>
                                                <div id={`msg${index}`} className="message">
                                                    {item.body}
                                                </div>
                                            </li>
                                ]))
                        }
                        {
                            isTyping.status ?
                                <li className="you">
                                    <div className="message typing-indicator">
                                        <span></span>
                                        <span></span>
                                        <span></span>
                                    </div>
                                </li>
                                : null
                        }
                    </ul>
                    {
                        showChatScrollDown ?
                            <div className="downArrowDiv" onClick={() => scrollToBottom()}>
                                <span><i className="fas fa-angle-double-down"></i></span>
                            </div> : null
                    }
                </div>
                <div id="footer" className="d-flex">
                    <div style={{ position: "relative" }}>
                        <Button
                            className="iconButton trigger"
                            style={{ marginRight: "15px" }}
                            onLoad={loadEmojiKeyborad}
                        >
                            <i className="far fa-smile" style={{ color: "#384E73" }}></i>
                        </Button>
                    </div>
                    <Input
                        style={{ marginRight: "15px", border: "none" }}
                        placeholder="Type your message"
                        value={message}
                        onKeyDown={(e) => handleTyping(e)}
                        onChange={(e) => setMessage(e.target.value)}
                    ></Input>
                    <Button
                        id="sendButton"
                        className="iconButton d-flex flex-row justify-content-center align-items-center"
                        onClick={() => sendMessage()}
                    >

                        <p className="ml-2 mr-3 mt-3" style={{ color: "white", fontSize: "1rem" }}>Send</p>
                        <img
                            height="16px"
                            width="auto"
                            src={sendIcon} />

                    </Button>
                </div>
            </div>
        </div>
    )
}

export default ClientChat;